import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PublicSiteNavbar from '../../components/PublicSiteNavbar';
import PublicSiteFooter from '../../components/PublicSiteFooter';
import NonIndexableHelmet from '../../components/NonIndexableHelmet';
import { getLegalMeta } from '../../data/nonIndexableMeta';
import { useLocale } from '../../contexts/LocaleContext';
import { getDateLocale } from '../../utils/localePaths';
import { COMPANY, HOSTING } from '../../data/legalCompanyInfo';

const MentionsLegalesPage = () => {
  const { locale } = useLocale();
  const dateLoc = getDateLocale(locale);
  return (
    <div className="min-vh-100 bg-light legal-page">
      <NonIndexableHelmet {...getLegalMeta('/legal/mentions')} />
      <PublicSiteNavbar />

      {/* Content */}
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col lg={10} xl={8}>
            <Card className="shadow-sm border-0">
              <Card.Body className="p-3 p-md-4 p-lg-5">
                <h1 className="fw-bold mb-4">Mentions Légales</h1>
                <p className="text-muted mb-4">
                  Dernière mise à jour : {new Date().toLocaleDateString(dateLoc)}
                </p>

                <hr className="my-4" />

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">1. Éditeur du site</h2>
                  <p>
                    Le site internet <strong>{COMPANY.siteName}</strong> (accessible à l'adresse{' '}
                    <a href={COMPANY.siteUrl} target="_blank" rel="noopener noreferrer">
                      {COMPANY.siteUrl}
                    </a>
                    ) est édité par :
                  </p>
                  <ul className="list-unstyled ms-3">
                    <li><strong>Raison sociale :</strong> {COMPANY.name}</li>
                    <li><strong>Forme juridique :</strong> Société par Actions Simplifiée ({COMPANY.legalForm})</li>
                    <li><strong>Capital social :</strong> {COMPANY.capital}</li>
                    <li><strong>Siège social :</strong> {COMPANY.address}</li>
                    <li><strong>SIREN :</strong> {COMPANY.siren}</li>
                    <li><strong>SIRET :</strong> {COMPANY.siret}</li>
                    <li><strong>RCS :</strong> {COMPANY.rcs}</li>
                    <li><strong>N° TVA intracommunautaire :</strong> {COMPANY.vat}</li>
                    <li><strong>Adresse électronique :</strong> <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></li>
                  </ul>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">2. Directeur de la publication</h2>
                  <p>
                    Le directeur de la publication du site est <strong>Monsieur {COMPANY.director}</strong>,
                    en qualité de représentant légal de la société {COMPANY.name}.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">3. Hébergement</h2>
                  <p>Le site est hébergé par :</p>
                  <ul className="list-unstyled ms-3">
                    <li><strong>Hébergeur :</strong> {HOSTING.name}</li>
                    <li><strong>Adresse :</strong> {HOSTING.address}</li>
                    <li><strong>RCS :</strong> {HOSTING.rcs}</li>
                    <li><strong>Site web :</strong> <a href={HOSTING.website} target="_blank" rel="noopener noreferrer">{HOSTING.websiteLabel}</a></li>
                  </ul>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">4. Propriété intellectuelle</h2>
                  <p>
                    L'ensemble du contenu présent sur le site Assistance Video, incluant, de façon non limitative,
                    les graphismes, images, textes, vidéos, animations, sons, logos, gifs et icônes ainsi que leur
                    mise en forme sont la propriété exclusive de la société LEAGORA, à l'exception des marques,
                    logos ou contenus appartenant à d'autres sociétés partenaires ou auteurs.
                  </p>
                  <p>
                    Toute reproduction, distribution, modification, adaptation, retransmission ou publication,
                    même partielle, de ces différents éléments est strictement interdite sans l'accord exprès
                    par écrit de LEAGORA. Cette représentation ou reproduction, par quelque procédé que ce soit,
                    constitue une contrefaçon sanctionnée par les articles L.335-2 et suivants du Code de la
                    propriété intellectuelle.
                  </p>
                  <p>
                    Le non-respect de cette interdiction constitue une contrefaçon pouvant engager la
                    responsabilité civile et pénale du contrefacteur.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">5. Liens hypertextes</h2>
                  <p>
                    Le site peut contenir des liens hypertextes vers d'autres sites présents sur le réseau Internet.
                    Les liens vers ces autres ressources vous font quitter le site Assistance Video.
                  </p>
                  <p>
                    LEAGORA ne dispose d'aucun moyen pour contrôler les sites en connexion avec ses sites internet
                    et ne répond pas de la disponibilité de tels sites et sources externes, ni ne la garantit.
                    Elle ne peut être tenue pour responsable de tout dommage, de quelque nature que ce soit,
                    résultant du contenu de ces sites ou sources externes, et notamment des informations, produits
                    ou services qu'ils proposent, ou de tout usage qui peut être fait de ces éléments.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">6. Responsabilité</h2>
                  <p>
                    LEAGORA s'efforce d'assurer au mieux de ses possibilités, l'exactitude et la mise à jour des
                    informations diffusées sur ce site, dont elle se réserve le droit de corriger, à tout moment
                    et sans préavis, le contenu.
                  </p>
                  <p>
                    Toutefois, LEAGORA ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations
                    mises à disposition sur ce site. En conséquence, LEAGORA décline toute responsabilité pour toute
                    imprécision, inexactitude ou omission portant sur des informations disponibles sur le site.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">7. Droit applicable et juridiction compétente</h2>
                  <p>
                    Les présentes mentions légales sont régies par le droit français. En cas de litige et à défaut
                    d'accord amiable, le litige sera porté devant les tribunaux français conformément aux règles
                    de compétence en vigueur.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 fw-bold mb-3">8. Contact</h2>
                  <p>
                    Pour toute question ou demande d'information concernant le site, ou tout signalement de
                    contenu ou d'activités illicites, l'utilisateur peut contacter l'éditeur à l'adresse
                    suivante : <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
                  </p>
                </section>
              </Card.Body>
            </Card>

            {/* Navigation vers autres pages légales */}
            <div className="mt-4 text-center">
              <p className="text-muted small mb-2">Voir aussi :</p>
              <div className="d-flex flex-wrap justify-content-center gap-3">
                <Link to="/legal/cgu/" className="text-decoration-none">CGU</Link>
                <span className="text-muted">•</span>
                <Link to="/legal/cgv/" className="text-decoration-none">CGV</Link>
                <span className="text-muted">•</span>
                <Link to="/legal/privacy/" className="text-decoration-none">Confidentialité</Link>
                <span className="text-muted">•</span>
                <Link to="/legal/rgpd/" className="text-decoration-none">RGPD</Link>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <PublicSiteFooter />
    </div>
  );
};

export default MentionsLegalesPage;

